import { render, staticRenderFns } from "./CardBringBackBush.vue?vue&type=template&id=61e33082&"
import script from "./CardBringBackBush.vue?vue&type=script&lang=js&"
export * from "./CardBringBackBush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports